export const setURLSearchParam = (entry, key, value, pushState = false) => {
    entry.searchParams.set(key, value)
    if(pushState){ window.history.pushState({ path: entry.href }, '', entry.href) }
}